import type { SuitabilityTestDefinition } from 'src/suitability/engine/types';
import type { ConsilioAnswers } from './answers';
import {
  isAdditionalComplete,
  isBlock1Complete,
  isBlock2Complete,
  isBlock3Complete,
} from './completeness';
import { StepBlock1 } from './step-block1';
import { StepBlock2 } from './step-block2';
import { StepAdditional } from './step-additional';
import { StepBlock3 } from './step-block3';
import { StepSustainability } from './step-sustainability';
import { isSustainabilityComplete } from './sustainability';

export const consilioV1: SuitabilityTestDefinition<ConsilioAnswers> = {
  company: 'consilio',
  version: 'v1',
  initialAnswers: {},
  steps: [
    {
      stepKey: 'block1',
      Component: StepBlock1,
      isComplete: isBlock1Complete,
    },
    {
      stepKey: 'block2',
      Component: StepBlock2,
      isComplete: isBlock2Complete,
    },
    {
      stepKey: 'block3',
      Component: StepBlock3,
      isComplete: isBlock3Complete,
    },
    {
      stepKey: 'additional',
      Component: StepAdditional,
      isComplete: isAdditionalComplete,
    },
    {
      stepKey: 'sustainability',
      Component: StepSustainability,
      isComplete: isSustainabilityComplete,
    },
  ],
};
